import React from 'react'
import { motion } from 'framer-motion'
import Contact from '../components/Contact'
import SEOMetaTags from '../components/SEOMetaTags'

const ContactPage = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "mainEntity": {
      "@type": "Organization",
      "name": "NorCal Cane Corso Puppies",
      "email": "info@majesticcorsokennels.com",
      "url": "https://majesticcorsokennels.com",
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+1-555-123-4567",
        "contactType": "Customer Service",
        "email": "info@majesticcorsokennels.com",
        "availableLanguage": "English",
        "areaServed": [
          "Northern California",
          "California",
          "United States"
        ],
        "hoursAvailable": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday", 
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday"
          ],
          "opens": "08:00",
          "closes": "20:00"
        }
      },
      "address": {
        "@type": "PostalAddress",
        "addressRegion": "CA",
        "addressCountry": "US",
        "addressLocality": "Northern California"
      },
      "hasMap": "https://maps.google.com/?q=Northern+California",
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 38.7783,
        "longitude": -121.302
      }
    }
  }

  return (
    <>
      <SEOMetaTags
        title="Contact Us - Get in Touch About Cane Corso Puppies"
        description="Contact NorCal Cane Corso Puppies today! Get information about available puppies, schedule visits, or ask questions about our Cane Corso breeding program. We respond within 24 hours."
        keywords="contact Cane Corso breeder, puppy inquiry, Northern California, dog breeder contact, Cane Corso questions, schedule puppy visit"
        canonical="/contact"
        ogTitle="Contact NorCal Cane Corso Puppies - Puppy Inquiries Welcome"
        ogDescription="Ready to find your perfect Cane Corso companion? Contact our professional breeding team for puppy availability, visits, and all your questions. Fast response guaranteed!"
        structuredData={structuredData}
      />
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="page-wrapper"
      >
        <Contact />
      </motion.div>
    </>
  )
}

export default ContactPage